import { getCsrfToken } from "@utils/csrfUtils";

export async function fetchBookmarkChange(dataId: string, bookmarked: boolean): Promise<void> {
  const response = await fetch(`/summary-ix/${dataId}/bookmark`, { method: bookmarked ? "POST" : "DELETE", headers: { "X-XSRF-Token": await getCsrfToken() } });
  if (!response.ok) {
    throw Error(`Could not fetch book mark change. Bookmarked: ${bookmarked}, Summary ID: ${dataId}`);
  }
}
